import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function PutClient(data) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/' + data.uuid, {
            method: 'PUT',
            headers: { 'Authorization' : unHashedJwt.data},
            data: {
                "clientName": data.clientName.trim(),
                "clientFullAddress": data.clientFullAddress.trim(),
                "contactPhoneNumber": data.contactPhoneNumber.trim(),
                "contactEmail": data.contactEmail.trim(),
                "clientVatNumber": data.clientVatNumber.trim(),
                "clientCountrySpecificVatNumber": data.clientCountrySpecificVatNumber.trim(),
                "countryUuid": data.countryUuid.trim(),
                "clientTypeUuid": data.clientTypeUuid.trim(),
                "domainLabel": data.domainLabel.trim(),
                "inVatSystem": data.inVatSystem
            }      
        }).then(
            res => (res)
        ).catch(error => error.response.data),
        "Admin"
    )
}